import { checkObservationFormType } from "src/utils/checkObservationFormType";

interface ObservationModalSelection {
	storeId?: number;
	userId?: string;
	month?: number;
}

/**
 * Decides whether the report observation modal should open.
 *
 * The modal must only open when a specific observation is drilled into by
 * clicking a month cell in the table:
 *  - user-based forms set `userId` (+ `month`) from the user cell
 *  - store-based forms set `storeId` + `month` from the store cell
 *
 * Selecting a store/employee from the search box sets `storeId` (and region/
 * area) WITHOUT a `month`, so it must filter the table rather than open the
 * modal. Gating store-based forms on `month` is what separates the two: the
 * only place that sets `month` for a store form is the clickable store cell.
 */
const shouldOpenObservationModal = (
	observationType: IObservationType | undefined,
	{ storeId, userId, month }: ObservationModalSelection
): boolean => {
	if (!observationType) return false;

	if (checkObservationFormType(observationType) === "user") {
		return Boolean(userId);
	}

	return Boolean(storeId && month);
};

export default shouldOpenObservationModal;
